<template>
  <div :class="{ active: selected, checked: isChecked }" class="customer-table__entry">
    <!-- Image -->
    <div @click="handleSelect(customer)" class="customer-table__item customer-table__image">
      <div class="customer-table__avatar">
        <placeholder-avatar :initials="initials"/>
      </div>
      <div class="customer-table__check">
        <q-checkbox v-model="checked" />
      </div>
    </div>

    <!-- Name -->
    <div @click="handleSelect(customer)"
         :class="{ 'small': small, 'customer-table__item--two-lines': customer.company }"
         class="customer-table__item customer-table__name"
    >
      <span class="q-body-2">{{ fullName }}</span>
      <span v-if="customer.company" class="text-faded">{{ customer.company.data.name }}</span>
    </div>

    <!-- Email -->
    <div v-show="!small" class="customer-table__item customer-table__email gt-lg">
      <a :href="'mailto:' + email">{{ email }}</a>
    </div>

    <!-- Phone -->
    <div v-show="!small" class="customer-table__item customer-table__phone gt-lg">
      {{ phone }}
    </div>

    <!-- Tools -->
    <div v-show="!small" class="q-pr-md customer-table__item customer-table__tools">
      <q-btn icon="more_vert" color="grey-7" flat round dense>
        <customer-popover :customers="[customer]"></customer-popover>
      </q-btn>
    </div>

    <!-- Deselect -->
    <div v-show="selected" @click="handleDeselect" class="customer-table__item customer-table__deselect">
      <q-icon name="close" />
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import CustomerPopover from '../CustomerPopover.vue'
  import PlaceholderAvatar from 'src/components/Common/PlaceholderAvatar.vue'
  import { getCustomerName } from 'src/utils/searchResultParser'

  export default {
    data () {
      return {
        checked: false
      }
    },

    computed: {
      ...mapGetters(['selectedCustomer', 'activeTeam', 'checkedCustomers']),

      small () {
        return this.selectedCustomer !== null
      },

      selected () {
        return this.selectedCustomer && parseInt(this.customer.id) === parseInt(this.selectedCustomer.id)
      },

      fullName () {
        return getCustomerName(this.customer)
      },

      phone () {
        return this.customer.default_phone_number ? this.customer.default_phone_number.data.number : ''
      },

      email () {
        return this.customer.default_email_address ? this.customer.default_email_address.data.email : ''
      },

      initials () {
        let first = this.customer.first_name ? this.customer.first_name.charAt(0) : ''
        let last = this.customer.last_name ? this.customer.last_name.charAt(0) : ''

        return (first + last).toUpperCase()
      },

      isChecked () {
        return this.checkedCustomers.includes(this.customer)
      }
    },

    props: {
      customer: {
        type: Object,
        required: true
      }
    },

    methods: {
      ...mapActions(['deselectCustomer', 'checkCustomer', 'deleteCustomer']),

      handleSelect (customer) {
        this.$router.push({ name: 'customer', params: { customerId: customer.id, teamId: this.activeTeam.id } })
      },

      handleDeselect () {
        this.deselectCustomer()
          .then(this.$router.push({ name: 'customers', params: { teamId: this.activeTeam.id } }))
      }
    },

    watch: {
      checked (newVal, oldVal) {
        this.checkCustomer({ customer: this.customer, value: newVal })
      }
    },

    components: {
      PlaceholderAvatar,
      CustomerPopover
    }
  }
</script>
